import * as Yup from 'yup';

export const audit_schema = {
  auditName: '',
  customerId: '',
  users: [],
};

export const audit_validation_schema = Yup.object({
  auditName: Yup.string().required('Audit name is required'),
  customerId: Yup.string().required('Customer is required'),
  users: Yup.array().required('Auditor is required').min(1, 'At least one auditor must be assigned'),
});
